import { Routes } from '@angular/router';
import { hisRootRoutes } from 'hisng';

const ROUTES: Routes = [
    {
        path: 'admissionPackage',
        loadChildren: () => import( './cm/app/admission/admissionPackage/admissionPackage-core.module' ).
            then( m => m.AdmissionPackageCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    },
    {
        path: 'allocationScheme',
        loadChildren: () => import( './cm/app/admission/allocationScheme/allocationScheme-core.module' ).
            then( m => m.AllocationSchemeCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    },
    {
        path: 'examination',
        loadChildren: () => import( './cm/app/entranceExamination/entranceExamination-core.module' )
            .then( m => m.EntranceExaminationCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    },
    {
        path: 'javascriptlibrary',
        loadChildren: () => import( './cm/app/javaScriptLibrary/javaScriptLibrary-core.module' )
            .then( m => m.JavaScriptLibraryCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    },
    {
        path: 'applicationDataStorage',
        loadChildren: () => import( './cm/app/applicationDataStorage/application-data-storage-core.module' )
            .then( m => m.ApplicationDataStorageCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    },
    {
        path: 'rectification',
        loadChildren: () => import( './cm/app/rectification/rectification-core.module' )
            .then( m => m.RectificationCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    },
    {
        path: 'application',
        loadChildren: () => import( './cm/app/application/application-core.module' )
            .then( m => m.ApplicationCoreModule ),
        data: {
            modules: ['HISINONEAPP']
        }
    }

];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AppRoutesModule = hisRootRoutes( ROUTES );
